import RootState from 'model/State/RootState';

export const selectTeams = (state: RootState) => state.user.teams;
export const selectIsFetchingTeams = (state: RootState) =>
  state.user.isFetchingTeams;
export const selectUsers = (state: RootState) => state.user.users;
export const selectIsFetchingUsers = (state: RootState) =>
  state.user.isFetchingUsers;
export const selectNextLink = (state: RootState) => state.user.nextLink;
